import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

/**
 * Convert a backend-relative asset path (e.g. `/api/uploads/sketch-abc.jpg`)
 * into an absolute URL that the browser can fetch. Passthrough for anything
 * that already starts with http(s):// or a data:/blob: scheme.
 */
export function resolveAssetUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  const s = String(pathOrUrl);
  if (/^(https?:|data:|blob:)/i.test(s)) return s;
  const cleaned = s.startsWith("/") ? s : `/${s}`;
  return `${BACKEND_URL}${cleaned}`;
}

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach bearer token as fallback (works even if cookies blocked)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("anu_token");
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Force logout when the backend reports account is suspended/deactivated/rejected mid-session.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const detail = String(error?.response?.data?.detail || "").toLowerCase();
    const isForcedLogout =
      status === 403 &&
      /(suspended|deactivated|rejected|not active)/.test(detail);
    if (isForcedLogout && localStorage.getItem("anu_token")) {
      localStorage.removeItem("anu_token");
      // Redirect only if we are not already on login/landing
      const p = window.location.pathname;
      if (!p.startsWith("/login") && !p.startsWith("/register") && p !== "/") {
        window.location.replace(`/login?forced=1&reason=${encodeURIComponent(detail)}`);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(", ");
  }
  return typeof detail === "object" ? JSON.stringify(detail) : String(detail);
}

export default api;
